<router-outlet></router-outlet>


// WEBPACK FOOTER //
// ./src/app/houses/houses-router.component.ts.HousesRouterComponent.html